import { ServiceFilterCriteria } from '../ServiceList/ServiceList.Menu';
import { ServiceExportFilter } from '../../../models/Entities/Service';

export const toISOStringOrUndefined = (date?: Date): string | undefined => {
  if (!date) {
    return undefined;
  }

  return date.toISOString();
};

export const buildServiceExportFilter = (
  filterCriteria: ServiceFilterCriteria,
  searchCriteria?: string
): ServiceExportFilter => ({
  DateFrom: toISOStringOrUndefined(filterCriteria.startDate),
  DateTo: toISOStringOrUndefined(filterCriteria.endDate),
  SearchText: searchCriteria || undefined,
  PageNumber: 1,
  PageSize: 1000
});

export const buildExportFileName = (): string => {
  const now = new Date();
  const date = now.toISOString().slice(0, 10);
  return `Servicios_Protocolo_${date}.xlsx`;
};
